import { render, staticRenderFns } from "./BtnImprimirPedido.vue?vue&type=template&id=79e70c01&"
import script from "./BtnImprimirPedido.vue?vue&type=script&lang=js&"
export * from "./BtnImprimirPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports